import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getBaseURL } from "../../../env/stage";
import AtlassianFormBuilder, { getValue } from "../../../formBuilder/AtlassianFormBuilder";
import { passwordFields, sendAccessTokenReqOptions } from "../../../common/constants/core/oauth2.constants";
import { clone, nullToEmptyString } from "../../../common/utils/helper";
import { modifySelectedCred } from "../../../redux/actions/credActions";
import CopyTextButton from "../../../common/components/CopyTextButton";
import { OAuth2SendAs } from "../../../common/interfaces/credentials/Credentials";

const GrantTypePasswordForm = () => {
  const [values, setValues] = useState([]);
  const selectedCred = useSelector((state) => state.auth.selectedCred);
  const CALLBACK_URL = getBaseURL() + "/credentials/oauth2/callback/" + selectedCred.id + "/" + selectedCred.clientKey;
  const dispatch = useDispatch();

  useEffect(() => {
    setValues([
      {
        id: "NAME",
        value: nullToEmptyString(selectedCred.name),
      },
      {
        id: "USERNAME",
        value: nullToEmptyString(selectedCred?.data?.config?.username),
      },
      {
        id: "PASSWORD",
        value: nullToEmptyString(selectedCred?.data?.config?.password),
      },
      {
        id: "ACCESS_TOKEN_URL",
        value: nullToEmptyString(selectedCred?.data?.config?.url?.accessTokenUrl),
      },
      {
        id: "CLIENT_ID",
        value: nullToEmptyString(selectedCred?.data?.config?.client?.id),
      },
      {
        id: "CLIENT_SECRET",
        value: nullToEmptyString(selectedCred?.data?.config?.client?.secret),
      },
      {
        id: "SCOPE",
        value: nullToEmptyString(selectedCred?.data?.config?.scope),
      },
      {
        id: "INCLUDE_STATE",
        value: selectedCred?.data?.config?.includeState ? selectedCred?.data?.config?.includeState : false,
      },
      {
        id: "AUTHORIZATION_HEADER_PREFIX",
        value: selectedCred?.data?.config?.headerPrefix ?? "Bearer",
      },

      {
        id: "INCLUDE_SCOPE_IN_ACCESS_TOKEN_REQ",
        value: selectedCred?.data?.config?.includeScopeInAccessTokenReq ? selectedCred?.data?.config?.includeScopeInAccessTokenReq : false,
      },
      {
        id: "MAKE_ACCESS_TOKEN_REQUEST_AS",
        value: selectedCred?.data?.config?.sendParamsAs ? selectedCred?.data?.config?.sendParamsAs : OAuth2SendAs.QUERY_PARAMS,
      },
      {
        id: "URL_ENCODE",
        value: selectedCred?.data?.config?.urlEncode ? selectedCred?.data?.config?.urlEncode : false,
      },
    ]);
  }, [selectedCred]);

  const callback = (extConfigValues) => {
    let credentials = clone(selectedCred);
    credentials.name = extConfigValues.find((v) => v.id === "NAME").value;
    if (!credentials.data) {
      credentials["data"] = {
        config: {
          client: {
            id: "",
            secret: "",
          },
          url: {
            accessTokenUrl: "",
          },
          grantType: "",
          scope: "",
          headerPrefix: "Bearer",
          state: "",
          includeState: true,
          username: "",
          password: "",
          includeScopeInAccessTokenReq: true,
          sendParamsAs: OAuth2SendAs.QUERY_PARAMS,
          urlEncode: false,
        },
      };
    }

    const data = credentials.data ? credentials.data : {};
    const config = credentials.data?.config ? credentials.data.config : {};
    const client = credentials.data?.config?.client ? credentials.data.config.client : {};
    const url = credentials.data?.config?.url ? credentials.data.config.url : {};

    client["id"] = getValue(extConfigValues, "CLIENT_ID");
    client["secret"] = getValue(extConfigValues, "CLIENT_SECRET");
    config["username"] = getValue(extConfigValues, "USERNAME");
    config["password"] = getValue(extConfigValues, "PASSWORD");
    url["accessTokenUrl"] = getValue(extConfigValues, "ACCESS_TOKEN_URL");
    config["scope"] = getValue(extConfigValues, "SCOPE");
    config["headerPrefix"] = getValue(extConfigValues, "AUTHORIZATION_HEADER_PREFIX");
    config["includeState"] = getValue(extConfigValues, "INCLUDE_STATE");
    config["includeScopeInAccessTokenReq"] = getValue(extConfigValues, "INCLUDE_SCOPE_IN_ACCESS_TOKEN_REQ");
    config["sendParamsAs"] = getValue(extConfigValues, "MAKE_ACCESS_TOKEN_REQUEST_AS");
    config["urlEncode"] = getValue(extConfigValues, "URL_ENCODE");

    config["client"] = client;
    config["url"] = url;
    data["config"] = config;
    credentials["data"] = data;

    dispatch(modifySelectedCred(credentials));
  };

  return (
    <>
      <AtlassianFormBuilder fields={passwordFields} values={values} options={sendAccessTokenReqOptions} update={callback} />
      <br />
      <br /> Callback url: <b>{CALLBACK_URL}</b>
      <CopyTextButton copyText={CALLBACK_URL} />
      <br />
      <br />
      <br />
    </>
  );
};

export default GrantTypePasswordForm;
